import { axiosService } from '@services'

import { API } from '../endPoints'

export default async function getPlantDetail(plantId: string) {
  const apiPath = `${API.PLANT_DATA}/${plantId}`
  return axiosService({ method: 'GET', apiPath })
}
